import { gql, useMutation } from '@apollo/client';

export enum MeetingAccessEventType {
  GRANTED = 'GRANTED',
  DENIED = 'DENIED',
}

type AdmitVisitorVariables = {
  conversationSid?: string;
  eventType: MeetingAccessEventType;
  roomName: string;
  visitorName: string;
  visitorUuid: string;
  patientShortId?: string;
  isZoomEnabled?: boolean;
  admissionTransactionId?: string;
};

type AdmitVisitorData = {
  updateTwilioVisitorMeetingAccess: {
    eventType: MeetingAccessEventType;
    updatedAt: string;
    appointmentShortId?: string;
    admissionTime?: string;
    isMinor: boolean | null;
  };
};

export function useAdmitVisitorMutation() {
  return useMutation<AdmitVisitorData, AdmitVisitorVariables>(gql`
    mutation UpdateTwilioVisitorMeetingAccess(
      $conversationSid: String
      $roomName: String!
      $visitorName: String!
      $visitorUuid: String!
      $eventType: MeetingAccessEventType!
      $patientShortId: String
      $isZoomEnabled: Boolean
      $admissionTransactionId: String
    ) {
      updateTwilioVisitorMeetingAccess(
        conversationSid: $conversationSid
        roomName: $roomName
        visitorName: $visitorName
        visitorUuid: $visitorUuid
        eventType: $eventType
        patientShortId: $patientShortId
        isZoomEnabled: $isZoomEnabled
        admissionTransactionId: $admissionTransactionId
      ) {
        eventType
        updatedAt
        admissionTime
        isMinor
      }
    }
  `);
}
